'use client';

import React from 'react';
import { CustomArrowProps } from 'react-slick';
import classNames from 'classnames';

type CustomArrows = CustomArrowProps & {
  disabled?: boolean;
  direction: 'left' | 'right';
  arrowClasses?: string;
};

export const Arrow = (props: CustomArrows) => {
  const { className, onClick, disabled, direction, arrowClasses } = props;

  if (disabled) return null;

  let rotate;
  switch (direction) {
    case 'right':
      rotate = 'rotate-0';
      break;
    case 'left':
      rotate = 'rotate-180';
      break;
    default:
      rotate = 'rotate-90';
      break;
  }

  return (
    <div
      className={classNames(
        className,
        'transform text-indigo hover:text-[#4055A5]',
        rotate,
      )}
      onClick={onClick}
      data-testid={`carousel-arrow-${direction}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        className={arrowClasses}
      >
        <defs>
          <clipPath>
            <path
              fill="currentColor"
              fillOpacity=".514"
              d="m-7 1024.36h34v34h-34z"
            />
          </clipPath>
          <clipPath>
            <path
              fill="currentColor"
              fillOpacity="1"
              d="m-6 1028.36h32v32h-32z"
            />
          </clipPath>
        </defs>
        <path
          d="m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373"
          transform="matrix(.03541-.00013.00013.03541 2.98 3.02)"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
